import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import BusinessLogin from './pages/login/BusinessLogin';
import Signup from './pages/signup';
import Forgot from './pages/forgot';
import ForgotOtp from './pages/otp';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Products from './pages/Product/Product';
import AddProduct from './pages/Product/AddProduct';
import EditProduct from './pages/Product/EditProduct';
import ProductDetails from './pages/Product/ProductDetials';
import Orders from './pages/Order/OrderList';
import ProfileBusiness from './pages/Profile/ProfileBusiness';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './components/ProtectedRoute';
import OrderDetails from './pages/Order/OrderDetails';
import Support from './pages/Support/support';

import Manufacturers from './pages/Enterprise/Manufacturers';
import Campaigns from './pages/Enterprise/Campaigns';
import AIAssistant from './pages/Enterprise/AIAssistant';
import Calculator from './pages/Enterprise/Calculator';
import Reports from './pages/Enterprise/Reports';
import IssueList from './pages/IGM/IssueList';
import { isBusinessDomain } from './utils/domainConfig';

const App: React.FC = () => {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        {/* Root redirect: business domain → /business-login, others → /login */}
        <Route
          index
          path="/"
          element={<Navigate to={isBusinessDomain() ? '/business-login' : '/login'} replace />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/business-login" element={<BusinessLogin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/forgot-otp/:id" element={<ForgotOtp />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="products/add" element={<AddProduct />} />
          <Route path="products/edit/:id" element={<EditProduct />} />
          <Route path="products/details/:id" element={<ProductDetails />} />
          <Route path="order/details/:id" element={<OrderDetails />} />
          <Route path="orders" element={<Orders />} />
          <Route path="account" element={<ProfileBusiness />} />
          <Route path="contact-us" element={<Support />} />
          
          {/* New Dashboard Modules */}
          <Route path="manufacturers" element={<Manufacturers />} />
          <Route path="calculator" element={<Calculator />} />
          <Route path="reports" element={<Reports />} />
          <Route path="issues" element={<IssueList />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="ai-assistant" element={<AIAssistant />} />
        </Route>

        {/* Optional: Catch-all 404 */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </>
  );
};

export default App;
